<div class="container">
  @if (user !== null) {
    <div class="main-wrapper">
      @if (userIsCurrentUser) {
        <div class="page-header-title" i18n>Your profile</div>
        <div class="page-sub-header" i18n>View and edit your personal information</div>
      } @else {
        <div class="page-header-title">{{ user.firstName }} {{ user.lastName }}</div>
        <div class="page-sub-header" i18n>View and edit personal information</div>
      }
      <div class="content-card-background">
        <h2 i18n>Personal information</h2>
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
          <div class="input-row">
            <div class="photo-label-wrapper">
              <label class="photo-label" i18n>Profile Photo</label>
            </div>
            <div class="image-upload">
              <input type="file" accept="image/jpeg,image/png" (change)="imageUpload($event)" />
              @if (photoDeleted) {
                <div class="photo-deleted"><i class="fal fa-user"></i></div>
              }
              @if (files.length === 0) {
                <img src="{{ user.photo }}" alt="" />
              }
              @if (files.length === 1) {
                <img src="{{ files[0].base64 }}" alt="" />
              }
              <div class="image-upload-bottom">
                <p i18n>Change</p>
              </div>
            </div>
            @if (!photoDeleted) {
              <div class="remove-photo-text-wrapper">
                <i class="remove-photo-icon far fa-minus-circle" (click)="removePhoto()"></i>
                <p class="remove-photo-text-button" (click)="removePhoto()" i18n>Remove photo</p>
              </div>
            }
          </div>
          <div class="input-row">
            <label for="fname" i18n>First name</label>
            <div>
              <input type="text" id="fname" [formControl]="form.controls.firstName" />
              <app-generic-error [control]="form.get('firstName')"></app-generic-error>
            </div>
          </div>
          <div class="input-row">
            <label for="lname" i18n>Last name</label>
            <div>
              <input type="text" id="lname" [formControl]="form.controls.lastName" />
              <app-generic-error [control]="form.get('lastName')"></app-generic-error>
            </div>
          </div>
          <div class="input-row">
            <label for="position" i18n>Position</label>
            <div>
              <input type="text" id="position" [formControl]="form.controls.function" />
              <app-generic-error [control]="form.get('function')"></app-generic-error>
            </div>
          </div>
          @if (userIsCurrentUser) {
            <div class="current-user">
              <div class="input-row">
                <label for="email" i18n>E-mail</label>
                <div>
                  <input type="text" id="email" [formControl]="form.controls.email" />
                  <app-generic-error [control]="form.get('email')"></app-generic-error>
                </div>
              </div>
              <div class="input-row">
                <label for="phone" i18n>Phone number</label>
                <div>
                  <ngx-material-intl-tel-input
                    id="phone"
                    class="tel-input"
                    [fieldControl]="form.controls.phone"
                    [preferredCountries]="[CountryISO.Netherlands]"
                    [autoSelectedCountry]="CountryISO.Netherlands"
                    [autoIpLookup]="false"
                    [autoSelectCountry]="true"
                    [enablePlaceholder]="false"
                    [enableSearch]="true"
                    [numberValidation]="true"
                    [includeDialCode]="false"
                    [hidePhoneIcon]="true"
                    [textLabels]="phoneTextLabels"></ngx-material-intl-tel-input>
                  <app-generic-error [control]="form.get('phone')"></app-generic-error>
                </div>
              </div>
            </div>
          }
          @if (!userIsCurrentUser) {
            <div class="not-current-user">
              <div class="input-row">
                <label i18n>E-mail</label>
                <p [ngStyle]="user.email === '' && {'margin-top': '45px'} || {}" class="input-row-text">{{ user.email }}</p>
              </div>
              <div class="input-row">
                <label i18n>Phone number</label>
                <p [ngStyle]="user.phone === '' && {'margin-top': '45px'} || {}" class="input-row-text">{{ user.phone }}</p>
              </div>
            </div>
          }
          <div class="input-row">
            <label i18n>Language</label>
            <div class="button-group-border">
              <div class="button-group">
                <div class="group-button" (click)="language = LanguageType.DUTCH" [class.selected]="language === LanguageType.DUTCH">
                  <a i18n>Dutch</a>
                </div>
                <div class="group-button" (click)="language = LanguageType.ENGLISH" [class.selected]="language === LanguageType.ENGLISH">
                  <a i18n>English</a>
                </div>
              </div>
            </div>
          </div>
          @if (userIsAdmin && !superAdmin) {
            <div class="admin-row">
              <label i18n class="admin-label">Admin</label>
              <input type="checkbox" id="admin" [checked]="admin" (click)="toggleAdmin()" />
              <label class="checkbox-label" for="admin"></label>
              <label class="checkbox-option" for="admin" i18n>Yes, user has admin rights</label>
            </div>
          }
          @if (
            !userIsCurrentUser && currentUser !== null && (currentUser.role === RoleType.ADMIN || currentUser.role === RoleType.SUPERADMIN)
          ) {
            <div class="label-row">
              <label i18n>Available labels</label>
              @if (admin) {
                <label class="admin-user-label" i18n>All labels</label>
              } @else {
                <div class="input-wrapper">
                  <app-multi-select
                    [labels]="labels"
                    [showControlButtons]="true"
                    [formControl]="form.controls.labels"
                    [multiSelectType]="MultiSelectType.LABEL"></app-multi-select>
                </div>
              }
            </div>
          }
          <div class="row footer-row">
            <button (click)="navigateBack()" class="skideo-flat-button white img-left">
              <img src="assets/icons/arrow-left.svg" alt="" />
              <span i18n>Previous</span>
            </button>
            <button class="skideo-flat-button green" type="submit" i18n>Save changes</button>
          </div>
        </form>
      </div>
    </div>
  }
</div>
